import { useMemo, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { NavMenu, PivotItem, PivotOuterIndex } from 'components/common'

import { useQuery } from 'hooks/useQuery'

import { CsvAutoRecordsDeleteTab } from './CsvAutoRecordsDeleteTab'
import { CsvAutoRecordsUploadTab } from './CsvAutoRecordsUploadTab'

const TAB_TYPES = {
  UPLOAD: 'upload',
  DELETE: 'delete',
} as const

type TabType = (typeof TAB_TYPES)[keyof typeof TAB_TYPES]

const tabs = [
  { header: '個人別作業実績数アップロード', key: TAB_TYPES.UPLOAD, component: <CsvAutoRecordsUploadTab /> },
  { header: '個人別作業実績数削除', key: TAB_TYPES.DELETE, component: <CsvAutoRecordsDeleteTab /> },
]

export const CsvAutoRecordsUpload = () => {
  const navigate = useNavigate()
  const { search } = useLocation()

  const [queryTab] = useQuery<TabType>('tab', TAB_TYPES.UPLOAD)
  const selectedTab = useMemo(() => (tabs.some(tab => tab.key === queryTab) ? queryTab : TAB_TYPES.UPLOAD), [queryTab])

  const handleTabChange = useCallback(
    (key: TabType) => {
      const params = new URLSearchParams(search)
      params.set('tab', key)
      navigate(`?${params.toString()}`, { replace: true })
    },
    [search, navigate]
  )

  return (
    <NavMenu>
      <div className="d-flex flex-column h-100 p-3 pb-0">
        <div className="mb-3 font-x-large fw-bold">個人別作業実績数</div>
        <PivotOuterIndex
          selectedIndex={tabs.findIndex(tab => tab.key === selectedTab)}
          onChange={index => handleTabChange(tabs[index].key)}
        >
          {tabs.map(({ header, key, component }) => (
            <PivotItem headerText={header} key={key}>
              {component}
            </PivotItem>
          ))}
        </PivotOuterIndex>
      </div>
    </NavMenu>
  )
}
